import _get from 'lodash/get';
import _keys from 'lodash/keys';
import _reduce from 'lodash/reduce';

export const getUnreadMessageCountByDashboardData = ({ dashboardData, dashboardDataEmpMember, currentThreadId }) => {
    // external messages count
    const unreadMessagesCounts = _get(dashboardData, 'unreadMsgsCounts');
    const threadIdList = _keys(unreadMessagesCounts);

    // internal messages count
    const unreadInternalMessagesCounts = _get(dashboardDataEmpMember, 'unreadMsgsCounts');
    const internalThreadIdList = _keys(unreadInternalMessagesCounts);

    // calculate the total unread messages count
    let unreadMessagesCount = _reduce(threadIdList, (total, threadId) => (threadId !== currentThreadId ? total + _get(unreadMessagesCounts, threadId, 0) : total), 0);
    unreadMessagesCount = _reduce(
        internalThreadIdList,
        (total, threadId) => (threadId !== currentThreadId ? total + _get(unreadInternalMessagesCounts, threadId, 0) : total),
        unreadMessagesCount,
    );

    return unreadMessagesCount;
};
